import CTNInput from '@ctn/ui/components/ctn-input';
import CTNModal from '@ctn/ui/components/ctn-modal';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';

import EventoListado from '@/components/EventoListado';

import { type Evento } from '@/interfaces/model/eventos.interface';

export type ModalHistorialUsuarioProps = {
	readonly onClose: () => void;
	readonly isOpen: boolean;
	readonly data: Data;
};

export type Data = {
	eventos: Evento[];
	username: string;
	nombre: string;
	apellido1: string;
	apellido2?: string;
	nombreEmisor: string;
};

export type Form = {
	eventos: Evento[];
	username: string;
	nombre: string;
	apellidos: string;
	nombreEmisor: string;
};

const ModalHistorialUsuario = ({ onClose, isOpen, data }: ModalHistorialUsuarioProps) => {
	const { control, watch, reset } = useForm<Form>();

	useEffect(() => {
		if (isOpen) {
			const { apellido1, apellido2, ...rest } = data;
			const apellidos = `${apellido1}${apellido2 ? ' ' + apellido2 : ''}`;
			reset({ ...rest, apellidos });
		}
	}, [isOpen]);

	return (
		<CTNModal
			closeable
			autoHeight			
			show={isOpen}
			type="basic"
			size="xxl"
			alignButtons="right"
			title="Historial del usuario"
			actionButtons={[
				{
					key: 'cerrar',
					mode: 'tertiary',
					label: 'Cerrar',
					minWidth: '140',
					size: 'size-40',
					onClick: onClose,
				},
			]}
			content={
				<>
					<div className="[ o-grid ] [ c-pnp-form-group c-pnp-form-group--accent c-pnp-form-group--radius c-pnp-form-group--display-only ] [ u-flow ]">
						<div className="o-grid__row">
							<CTNInput
								noFeedBack
								displayOnly
								condensed
								type="text"
								classNameField="o-grid__col-12 o-grid__col-3@portrait"
								name="username"
								label="Nombre de usuario"
								control={control}
							/>
							<CTNInput
								noFeedBack
								displayOnly
								condensed
								type="text"
								classNameField="o-grid__col-12 o-grid__col-3@portrait"
								name="nombre"
								label="Nombre"
								control={control}
							/>
							<CTNInput
								noFeedBack
								displayOnly
								condensed
								type="text"
								classNameField="o-grid__col-12 o-grid__col-3@portrait"
								name="apellidos"
								label="Apellidos"
								control={control}
							/>
							<CTNInput
								noFeedBack
								displayOnly
								condensed
								type="text"
								classNameField="o-grid__col-12 o-grid__col-3@portrait"
								name="nombreEmisor"
								label="Empresa"
								control={control}
							/>
						</div>
					</div>
					<EventoListado className="u-mt-24" data={watch('eventos') ?? []} />
				</>
			}
			onClose={onClose}
		/>
	);
};

export default ModalHistorialUsuario;
